import $http from "../h5-network/request.js";
import { saveLG } from "./lg.js";
import { MALE, FEMALE } from "../../../enum/GENDER.js";
import { SELF, MATE, CHILD } from "../../../enum/RELATION.js";
import riskIndex from "../utils/riskIndex.js";

import store from "../store/index.js";
import { ANSWER } from "../store/mutation-types.js";

import qs from "qs";
let { nickname, tmrId } = qs.parse(location.search.slice(1));

export const userAnswer = (answer) => {
    const selfData = answer.member.find((item) => item.relation == SELF);
    const mateData = answer.member.find((item) => item.relation == MATE);

    const childData = answer.member.filter(
        (item) => item.checked && item.relation == CHILD
    );
    let data = {
        age: selfData.age,
        gender: selfData.gender,
        city: answer.city,
        cityCode: answer.cityCode,
        complete: answer.complete, //0 未完成测评， 1 已完成
        family: 1,
        annualIncome: selfData.income,
        name: answer.name,
        questionNumber: answer.questionNumber,
    };

    nickname && (data.nickname = nickname);

    if (mateData.checked) {
        data.spouseAge = mateData.age;
        data.spouseAnnualIncome = mateData.income;
        data.family = 2;
    }

    if (childData.length) {
        data.childInfos = childData.map((item) => ({
            childAge: item.age,
            childGender: item.gender,
        }));
        data.family = 3;
    }
    return data;
};

export const saveEvaluateInfo = (answer) => {
    const data = userAnswer(answer);

    return $http({
        loading: true,
        url: "/bdzb-core-service/eva/saveEvaluateInfo",
        data,
        method: "POST",
    });
};

export const getUserAnswer = (fn) => {
    $http({
        loading: true,
        url: "/bdzb-core-service/eva/isRegularUser",
        data: {},
        method: "POST",
    }).then((data) => {
        const answer = store.state.answer;

        if (data.name) {
            const selfData = answer.member.find(
                (item) => item.relation == SELF
            );
            answer.gender = data.gender;
            selfData.gender = data.gender;
            answer.name = data.name;
            answer.cityCode = data.cityCode;
            answer.city = data.city;
            answer.complete = data.complete;
            selfData.age = data.age;
            selfData.income = data.annualIncome;
        }

        if (data.spouseAge) {
            const mateData = answer.member.find(
                (item) => item.relation == MATE
            );
            mateData.gender = answer.gender == MALE ? FEMALE : MALE;
            mateData.age = data.spouseAge;
            mateData.income = data.spouseAnnualIncome;
            mateData.checked = true;
        }
        if (data.childInfos && data.childInfos.length > 0) {
            answer.member = answer.member.filter(
                (item) => item.relation != CHILD
            );

            data.childInfos.forEach((item) =>
                answer.member.push({
                    relation: CHILD,
                    gender: item.childGender,
                    age: item.childAge,
                    checked: true,
                })
            );
        }
        for (const [key, val] of Object.entries(answer)) {
            store.commit(ANSWER, {
                idx: key,
                value: val,
            });
        }
        fn && fn(data);
    });
};

export const commonSaveEvaluateInfo = (answer) => {
    return function() {
        return saveEvaluateInfo(answer)
            .then(() => {
                //获客版测评完成发送LG
                !tmrId && saveLG({ method: 4 });

                //拉取报告页数据获取本人的已有保障和应有保障计算保障充足度
                return $http({
                    loading: true,
                    url: "/bdzb-core-service/eva/evaluateResult",
                    data: {},
                    method: "POST",
                });
            })
            .then(({ memberRecommends }) => {
                const self = memberRecommends[0];
                const seriesdata = {
                    shouldGuaranteed: self?.shouldGuaranteed || {},
                    guaranteeds: self?.guaranteeds || {},
                };
                const guaranteeIndex = riskIndex(seriesdata);
                console.log("风险指数：", guaranteeIndex);
                return $http({
                    loading: true,
                    url: "/bdzb-core-service/eva/saveUserGuaranteeIndex",
                    data: { guaranteeIndex },
                    method: "POST",
                });
            });
    };
};
